
import Vue from 'vue'
import {QSpinner, QTooltip, QBanner, QInput, QIcon, QSpace} from 'quasar'
import EntryCreateDialog from './EntryCreateDialog.vue'
import ListCreateDialog from './ListCreateDialog.vue'
import FilterSelector from './FilterSelector.vue'
import { apolloState } from '@/main';
import gql from 'graphql-tag';

export default Vue.extend({
    components: {QSpinner, QTooltip, QBanner, QInput, QIcon, QSpace, EntryCreateDialog, ListCreateDialog, FilterSelector},
    props: {
        listId: {
            type: String,
        },
        listName: {
            type: String
        },
        sharingList: {
            type: Object
        },
        filter: {
            type: Object
        },
        lists: {
            type: Array
        },
        users: {
            type: Array
        },
        selectedEntries: {
            type: Array
        },
    },
    data() {
        return {
            createDialog: false,
            createListDialog: false,
            isLoading: false
        }
    },
    computed: <any>{
        VERSION() {
           return __VERSION__;
        },
        apolloError() {
            return apolloState.wsError
        },
        foreignLists() {
          return this.lists.filter(l => l.id !== this.listId)
        }
    },
    methods: {
        async shareEntries() {
          this.isLoading = true
          try {
            const res = await this.$apollo.mutate({
              mutation: gql`
                mutation share($ids: [String!]!, $listId: String!, $targetListId: String!) {
                  shareEntries(targetListId: $targetListId, listId: $listId, ids: $ids)
                }
              `,
              variables: {
                ids: this.selectedEntries.map((s:any) => s.id),
                listId: this.listId,
                targetListId: this.sharingList.id
              }
            })
            this.$emit('cancelSharing')
          } catch(err) {
            console.error(err)
          }
          this.isLoading = false
        }
    }
})
